export default __webpack_public_path__ + "static/media/IraLippkeStudios_Lina_Shteyn_BarDivEng-015.05fcb755.jpg";